import LegalPage from "@/components/LegalPage";

/**
 * /imprint — Impressum / Anbieterkennzeichnung gemäß § 5 DDG.
 *
 * The Digitale-Dienste-Gesetz (DDG) has replaced the former Telemedien­gesetz
 * as the applicable German provider-identification law. All references on
 * this page therefore use DDG.
 *
 * TODO: Verify VSBG dispute-resolution wording before paid checkout goes
 * live, especially if employee count or legal obligations change.
 *
 * Note: Der Betreiber ist ein Einzelunternehmen ohne Handelsregister-
 * eintrag. Es wird daher kein Registereintragsabschnitt angezeigt.
 */
export default function Imprint() {
  return (
    <LegalPage
      title="Impressum"
      subtitle="Anbieterkennzeichnung gemäß § 5 DDG"
      updatedAt="05.07.2026"
    >
      <Section title="Anbieter">
        <address className="not-italic block bg-[#12141C] border border-[#1E212B] rounded-lg p-4 text-zinc-200 text-sm">
          Gökhan Tan<br />
          Einzelunternehmen<br />
          Jägerhofallee 34<br />
          71638 Ludwigsburg<br />
          Deutschland
        </address>
      </Section>

      <Section title="Kontakt">
        <p>
          E-Mail: <strong>pineforgeai@gmx.de</strong><br />
          Support: <strong>customerservice@pineforge.ai</strong><br />
          Telefon: <strong>+49-160-4526226</strong>
        </p>
      </Section>

      <Section title="Umsatzsteuer">
        <p>
          Umsatzsteuer-Identifikationsnummer gemäß § 27a UStG:{" "}
          <strong>DE352260563</strong>
        </p>
      </Section>

      <Section title="Vertreten durch">
        <p>Gökhan Tan, Inhaber</p>
      </Section>

      <Section title="Verantwortlich für Inhalte nach § 18 Abs. 2 MStV">
        <p>
          Gökhan Tan<br />
          Jägerhofallee 34<br />
          71638 Ludwigsburg<br />
          Deutschland
        </p>
      </Section>

      <Section title="Streitbeilegung">
        <p>
          Wir sind weder verpflichtet noch bereit, an Streitbeilegungs-
          verfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
        </p>
      </Section>

      <Section title="Haftung für Inhalte">
        <p>
          Als Diensteanbieter sind wir gemäß § 7 Abs. 1 DDG für eigene
          Inhalte auf diesen Seiten nach den allgemeinen Gesetzen
          verantwortlich. Nach §§ 8 bis 10 DDG sind wir jedoch nicht
          verpflichtet, übermittelte oder gespeicherte fremde Informationen
          zu überwachen.
        </p>
      </Section>

      <Section title="Marken- und Urheberrechtshinweis">
        <p>
          PineForge.AI ist ein unabhängiges Softwarewerkzeug und steht in
          keiner geschäftlichen Verbindung zu TradingView, Inc. TradingView®
          und Pine Script® sind Marken der jeweiligen Rechteinhaber.
        </p>
      </Section>
    </LegalPage>
  );
}

function Section({ title, children }) {
  return (
    <section>
      <h2 className="text-lg font-semibold text-white mb-3">{title}</h2>
      <div className="space-y-3">{children}</div>
    </section>
  );
}
